import { ERP } from '../_base/endpoint';
import axios from 'axios';


class estadoContribuyenteService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/estado-contribuyente`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new estadoContribuyenteService();